import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

const Header = ({ banner }) => {
  return (
    <div>
      <Img responsiveSizes={banner} />
    </div>
  );
};

Header.propTypes = {
  banner: PropTypes.object,
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.jsx